import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppUtilityService } from '../services/app-utility.service';
/**
 * Route guard that checks if a study is loaded before allowing navigation.
 * This guard uses the AppUtilityService to check the current state of the study.
 * If the study is loaded (returns true from `isStudyLoaded()`), navigation proceeds.
 * If not, the guard prevents navigation.
 */
export const stateGuard: CanActivateFn = () => {
  const appUtilityService = inject(AppUtilityService);

  return appUtilityService.isStudyLoaded();
}